import { FilterOption } from '../components/custom-input/FilterDropdown';
import { getStaffMembers } from '../api/staffMemberApi';
import { StaffMember } from '../types/interfaces/staffMember.interfaces';
import { UserInfo } from '../types/interfaces';

export const staffToOption = (staff: StaffMember): FilterOption<UserInfo> => ({
  name: `${staff.firstName ?? ''} ${staff.lastName ?? ''}`.trim() || 'Unknown',
  value: {
    userId: staff.staffId ?? 0,
    firstName: staff.firstName ?? '',
    lastName: staff.lastName ?? '',
  } as UserInfo,
});

export const loadRoleOptions = async (rsgUsers: FilterOption<UserInfo>[]) => {
  const [vetsRes, embRes, techRes] = await Promise.all([
    getStaffMembers({ filter: 'JobTitle eq Veterinarian' }),
    getStaffMembers({ filter: 'JobTitle eq Embryologist' }),
    getStaffMembers({ filter: 'JobTitle eq Technician' }),
  ]);

  return {
    vet: [...rsgUsers, ...vetsRes.data.map(staffToOption)],
    embryologist: [...rsgUsers, ...embRes.data.map(staffToOption)],
    tech: [...rsgUsers, ...techRes.data.map(staffToOption)],
  };
};
